import React, { useRef, useEffect, useState } from 'react'
import { Button } from 'primereact/button';
import { OverlayPanel } from 'primereact/overlaypanel';
import { InputText } from 'primereact/inputtext';
// Componentes Base y Llamadas a la API
import AgGrid from '../../../../Base/Components/Tables/AgGrid/AgGrid';
import { getProductosRequisa } from '../../../../API/Productos/ProductosRequests'

/**
 * COMPONENTE: RequisaProductosOverlayPanel
 * PROPÓSITO: Selector de productos mediante un panel flotante que contiene una tabla AgGrid.
 * * @param {Function} close - Función que se ejecuta al ocultar el panel.
 * @param {Object} rowData - Datos de la fila o registro actual (procedente del formulario padre).
 * @param {Function} onChange - Callback que retorna el producto seleccionado al componente padre.
 */
export const RequisaProductosOverlayPanel = ({ close, rowData, onChange }) => {

    // --- REFERENCIAS (REFS) --
    const op = useRef(null);      // Referencia para controlar el OverlayPanel (abrir/cerrar)
    const buttom = useRef(null);   // Referencia al botón disparador (usado como anclaje)

    // --- ESTADOS (STATE) ---
    const [loading, setLoading] = useState(false); // Estado de carga para la tabla
    const [productos, setProductos] = useState([]); // Almacena la lista de productos del servidor

    /**
     * EFECTO DE CARGA: obtenerProductos
     * Realiza la petición asíncrona a la API para obtener el catálogo de productos.
     */
    const obtenerProductos = async () => {
        setLoading(true);
        const tempo = await getProductosRequisa();
        setProductos(tempo); // Guarda la respuesta en el estado local
        setLoading(false);
    };

    /**
     * DEFINICIÓN DE COLUMNAS PARA AG-GRID
     * Determina cómo se visualizan los campos del catálogo en la tabla.
     */
    const colums = [
        {
            header: 'Codigo',
            field: 'Codigo',
            className: 'medium',

        },
        {
            header: 'Nombre Producto',
            field: 'NombreProducto',
            className: 'Xlarge',
        },
        {
            header: 'Inventario',
            field: 'Inventario',
            className: 'small',
        },
        {
            header: 'Unidad',
            field: 'UnitName',
            className: 'small',
        }
    ];

    /**
     * CONFIGURACIÓN DE LA TABLA AG-GRID
     * Encapsula los datos, columnas y eventos de interacción.
     */
    const table = {
        Columns: colums,
        Data: productos,
        loading: loading,
        // Cuando se hace clic en una celda, se propaga el evento al componente padre
        onCellClicked: e => onChange(e, rowData)
    };

    /**
     * CICLO DE VIDA (useEffect)
     * Dispara la carga de productos una única vez al montar el componente.
     */
    useEffect(() => {
        obtenerProductos();
    }, []);

    return (
        /* Contenedor principal con ancho máximo definido */
        <div style={{ maxWidth: '25vw' }}>
            {/* SECCIÓN: INPUT GROUP (TRIGGER) 
                Permite al usuario visualizar el producto actual y abrir el buscador */}
            <div className="p-inputgroup">
                {/* El Input muestra el nombre actual; al hacer clic también abre el panel */}
                <InputText value={rowData.NombreProducto} disabled placeholder="Producto" onClick={(e) => op.current.toggle(e)} />
                {/* Botón con icono de flecha hacia abajo para indicar que es un dropdown/panel */}
                <Button ref={buttom} icon='pi pi-chevron-down' style={{ padding: '0.5rem 0.3rem' }} type="button" onClick={(e) => op.current.toggle(e)} />
            </div>
                {/* SECCIÓN: OVERLAY PANEL (CONTENEDOR FLOTANTE) 
                Contiene la tabla AgGrid con el catálogo completo */}
            <OverlayPanel ref={op} showCloseIcon dismissable={false} className='OverPanelProductos' onHide={close} >
                {/* Dimensiones fijas para el contenedor de la tabla dentro del panel */}
                <div style={{ width: 600, height: 400 }}>
                    <AgGrid table={table} />
                </div>
            </OverlayPanel>
        </div>

    )
}
